import React from "react";
import { useNavigate } from "react-router-dom";
import SEO from "../../components/SEO";

const SunglassesForMen = () => {
  const navigate = useNavigate();

  return (
    <div style={{ padding: "20px", maxWidth: "900px", margin: "auto" }}>
      <SEO 
        title="Best Sunglasses for Men in India"
        description="Explore the best stylish sunglasses for men in India. Affordable, modern, and UV protected eyewear from Mark & Luth."
      />

      <h1>Best Sunglasses for Men in India</h1>

      <p>
        Sunglasses are not just about protection — they are a style statement. 
        Choosing the right sunglasses can completely transform your look.
      </p>

      <h2>Top Styles for Men</h2>
      <ul>
        <li>Aviator Style</li>
        <li>Square Frames</li>
        <li>Round Frames</li>
        <li>Sporty Designs</li>
      </ul>

      <h2>Why Choose Mark & Luth?</h2>
      <p>
        We focus on premium design, comfort, and affordability. 
        Our sunglasses are crafted to suit modern lifestyles.
      </p>

      <button onClick={() => navigate("/shop")} style={{ padding: "10px 20px", marginTop: "20px" }}>
        Shop Now
      </button>
    </div>
  );
};

export default SunglassesForMen;